import { IUpdateItensServicoEmpreendimentoUseCase } from "../../../presentation/useCases/update/update_itens_servico_empreendimento_use_case";
import { ItemServicoEmpreendimento } from "../../models/item_servico_empreendimento";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * updateItensServicoEmpreendimentoUseCase
 */

export class UpdateItensServicoEmpreendimentoUseCase implements IUpdateItensServicoEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async updateItensServicoEmpreendimento(
    listaItens: ItemServicoEmpreendimento[],
  ): Promise<void> {
    await this.repository.updateItensServicoEmpreendimento(
      listaItens
    );
  }

}
